/**
 * Der Aufbau der Rechtsseiten.
 *
 * Nur die Reihenfolge der Abschnitte steht hier - Überschriften und Fließtext
 * liegen unter `legal.<page>.sections.<key>` in de.json. Der Wortlaut stammt
 * vom Auftraggeber (WETTBANDIT-11, Datenschutztext.md und Impressum.md am
 * Ticket), die Zwischenüberschriften der Datenschutzerklärung sind von uns.
 */
export const PRIVACY_SECTIONS = [
    'participation',
    'data',
    'teachers',
    'archive',
    'hosting',
    'cookies',
] as const

export const IMPRINT_SECTIONS = [
    'provider',
    'represented',
    'contact',
    'dispute',
    'copyright',
] as const

export type LegalPage = 'privacy' | 'imprint'

export function sectionsFor(page: LegalPage): readonly string[] {
    return page === 'privacy' ? PRIVACY_SECTIONS : IMPRINT_SECTIONS
}
